import { AppState } from '../../..';
import { ActioningListComponentProperties, ActioningListComponent } from './actioning-list.component';
import { Dispatch, connect } from 'react-redux';
import { getActioningList, completeComment, beginLoadActions } from '../../actioning.actions';
import { CommentViewModel, CommentType } from '@models/Comment';
import { ModalProps } from '@common/components/modal/_components/modal.component';
import { toggleModal, toggleDialog } from '@common/components/common.actions';
import { saveComment, clearUsers } from 'src/comments/comments.actions';
import { actions } from 'react-redux-form';
import { OptionsViewModel } from '@models/common.models';
import FormNames from '@constants/FormNames.enum';

function mapStateToProps(state: AppState, ownProps: {}): Partial<ActioningListComponentProperties> {
  return {
    actioningList: state.actioning.actioningList,
    usersToAction: state.comment.usersToAction,
    pageNumber: state.actioning.pageNumber,
    pageSize: state.actioning.pageSize,
    totalResults: state.actioning.totalResults,
    pageCount: state.actioning.pageCount,
    loading: state.actioning.loading
  };
}

function mapDispatchToProps(dispatch: Dispatch<AppState>, ownProps: {}): Partial<ActioningListComponentProperties> {
  return {
    getActioningList(pageNumber: number, pageSize: number, orderDirection: string) {
      dispatch(beginLoadActions());
      dispatch(getActioningList(pageNumber, pageSize, orderDirection));
    },
    completeComment(oldComment: CommentViewModel, pageNumber: number) {
      dispatch(completeComment(oldComment.commentId, CommentType[oldComment.commentType])).then(() => {
        dispatch(getActioningList(pageNumber, 10, 'asc'));
        dispatch(actions.reset(FormNames.CommentForm));
        dispatch(clearUsers());
        dispatch(toggleModal());
      });
    },
    saveComment(newComment: CommentViewModel, usersToAction: OptionsViewModel[]) {
      dispatch(saveComment(newComment.entityId, CommentType[newComment.commentType], newComment, usersToAction));
    },
    toggleModal: (modalProps?: ModalProps) => {
      dispatch(toggleModal(modalProps));
    },
    toggleDialog: (comment: string) => {
      dispatch(toggleDialog({ textYes: 'Close', text: comment, onYesClick: () => toggleDialog() }));
    }
  };
}

export const ActioningList = connect(
  mapStateToProps,
  mapDispatchToProps
)(ActioningListComponent);



// WEBPACK FOOTER //
// ./src/actioning/_components/actioning-list/actioning-list.container.tsx